import { createSlice } from '@reduxjs/toolkit';

const pageStateSlice = createSlice({
  name: 'pageState',
  initialState: {},
  reducers: {
    savePageState: (state, action) => {
      state[action.payload.page] = action.payload.state;
    },
    resetPageState: (state, action) => {
      delete state[action.payload.page];
    },
  },
});

export const { savePageState, resetPageState } = pageStateSlice.actions;

export default pageStateSlice.reducer;
